import { render, staticRenderFns } from "./BatchDetails.vue?vue&type=template&id=dc1852a2&scoped=true"
import script from "./BatchDetails.vue?vue&type=script&lang=js"
export * from "./BatchDetails.vue?vue&type=script&lang=js"
import style0 from "./BatchDetails.vue?vue&type=style&index=0&id=dc1852a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc1852a2",
  null
  
)

export default component.exports